module.exports = __webpack_public_path__ + "img/weather47.059281fa.png";